/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ReportsUserViewUpdateRequest {
    getFixupPrototypeFunction() { return ReportsUserViewUpdateRequest.fixupPrototype; }

    static newInstance(model: Partial<ReportsUserViewUpdateRequest>): ReportsUserViewUpdateRequest {
        let obj = Object.assign(new ReportsUserViewUpdateRequest(), model);
        ReportsUserViewUpdateRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ReportsUserViewUpdateRequest>): ReportsUserViewUpdateRequest {
        if (!model) return null;
        return ReportsUserViewUpdateRequest.newInstance(<ReportsUserViewUpdateRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ReportsUserViewUpdateRequest) {
        if (!obj) return;

        models.ReportsUserViewUpdateRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ReportsUserViewUpdateRequest): boolean {
        Object.setPrototypeOf(obj, ReportsUserViewUpdateRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Id of the report
     */
    report_id: string;

    /**
     * Name of the View
     */
    view_name: string;

    /**
     * powerBI unique state id
     */
    state_id: string;

    /**
     * default view
     */
    default_view: boolean = false;

}
